import classNames from 'classnames';

import { RewardPoolSelfEntry } from '@shared/api/types/rewardPools';

import { TicketsListItem } from './TicketsListItem';
import { TicketsListSkeleton } from './TicketsListSkeleton';

type Props = {
  entries: RewardPoolSelfEntry[];
  isLoading: boolean;
  className?: string;
};

export const TicketsList = ({ entries, isLoading, className }: Props) => {
  const entriesList = entries.map((entry) => (
    <TicketsListItem key={entry.id} code={entry.id} isWinner={Boolean(entry.reward)} />
  ));

  return (
    <div className={classNames('flex flex-col', className)}>
      {isLoading ? <TicketsListSkeleton /> : entriesList}
    </div>
  );
};
